<script context="module" lang="ts">
	import Section from '$lib/components/layout/Section.svelte';
	import Media from '$lib/components/media/Media.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';

	export const config: SectionConfig = {
		collection: 'section_media',
		availableFor: ['posts'],
		query: gql`
			size
			columns
			items {
				section_media_item_id {
					media {
						...Media
					}
				}
			}
    `
	};
	type Props = {
		size: string;
		media: any;
		items: any;
		columns: number;
	};
</script>

<script lang="ts">
	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)
</script>

<Section
	class="section-blog-text"
	type={data.size === 'slim' ? 'slim' : data.size === 'full' ? 'full' : 'slim'}
>
	<div class="wrapper {data.size} columns-{data.columns}">
		{#each data.items as { section_media_item_id: item }}
			<Media {...item.media} transform="l" showImageDescription={true} fit="cover" />
		{/each}
	</div>
</Section>

<style lang="scss">
	.wrapper {
		@include font(text);

		:global(h2) {
			@include font(h2);
			margin-bottom: v(content-padding);
		}

		:global(h3) {
			@include font(h3);
			margin-bottom: v(content-padding-sm);
		}

		:global(p) {
			margin-bottom: 16px;
			margin-bottom: v(content-padding);
		}

		:global(strong) {
			font-weight: 600;
		}

		:global(blockquote) {
			text-align: center;
		}
		&.normal {
			aspect-ratio: 2/1;
			:global(img) {
				max-height: 800px;
			}
		}
		&.slim {
			aspect-ratio: 0/1;
			padding: 0 v(content-padding-4xl);
			:global(img) {
				max-height: 600px;
			}
		}
		display: grid;
		gap: v(content-gap);
		&.columns-1 {
			grid-template-columns: 1fr;
		}
		&.columns-2 {
			grid-template-columns: 1fr 1fr;
		}
		&.columns-3 {
			grid-template-columns: 1fr 1fr 1fr;
		}
	}
</style>
